/**
 * hyzebra Design System v1.6 — single source of truth for admin UI tokens.
 * MUI theme (palette, typography, component overrides) reads from these values.
 * Do not duplicate colors/spacing elsewhere; import adminTokens instead.
 */
export const adminTokens = {
    /* Neutrals */
    gray25: '#FCFCFC',
    gray50: '#FAFAFA',
    gray100: '#EEEEEE',
    gray200: '#E5E5E5',
    gray300: '#D4D4D4',
    gray400: '#A8ACB8',
    gray500: '#8B92A3',
    gray600: '#5A6172',

    /* Navy */
    navy900: '#0C1426',
    navy800: '#131C33',
    navy700: '#1E2A4A',

    /* Ink (primary action) */
    ink: '#131C33',
    inkHover: '#2A3552',
    inkFocus: 'rgba(19,28,51,.22)',

    /* Green */
    green700: '#126239',
    green600: '#15803D',
    green100: '#E4F3EA',

    /* AI accent */
    ai700: '#5B44B8',
    ai600: '#6E56CF',
    ai100: '#F0EDFB',
    aiFocus: 'rgba(110,86,207,.28)',

    /* Semantics */
    successText: '#126239',
    successBg: '#E4F3EA',
    warningText: '#92400E',
    warningBg: '#FCF0DC',
    warningSolid: '#D97706',
    errorText: '#B42318',
    errorBg: '#FBEAE8',
    errorSolid: '#D92D20',
    infoText: '#1D4ED8',
    infoBg: '#E9EFFD',
    infoBorder: '#C7D7FB',
    neutralText: '#5A6172',
    neutralBg: '#EEEEEE',

    /* Typography scale (px) */
    textXs: 12,
    textSm: 13,
    textBase: 14,
    textMd: 15,
    textLg: 16,
    textXl: 18,
    text2xl: 22,

    fontSans: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
    fontMono: "ui-monospace, 'SF Mono', Menlo, monospace",

    /* Layout */
    topbarH: 64,
    sidebarWidth: 264,
    inspectorWidth: 320,
    controlHsm: 32,
    controlHmd: 36,
    controlHlg: 40,
    tableRowH: 56,

    /* Radius */
    radius: '6px',
    radiusMd: '8px',
    radiusLg: '12px',
    radiusXl: '16px',
    radiusFull: '999px',

    /* Surfaces */
    bg: '#FAFAFA',
    surface: '#ffffff',
    borderMd: '1px solid #E5E5E5',

    /* Shadows */
    shadowCard: '0 1px 2px rgba(12,20,38,.05)',
    shadowDropdown: '0 4px 16px rgba(12,20,38,.10)',
    shadowModal: '0 12px 40px rgba(12,20,38,.18)',
} as const;

export type AdminTokens = typeof adminTokens;
